(function () {

    'use strict';

    angular.module('iplusjs.validator.iban', [
        'ngMessages',
        'lodash',
        'iplusjs.utils.misc',
        'iplusjs.utils.konto',
        'iplusjs.utils.formField',
        'iplusjs.config',
        'iplusjs.validator.add',
        'iplusjs.validator.group',
        'iplusjs.utils.removeWhitespace'
    ])
    .directive('iplusjsIbanValidator', ibanValidator);

    IbanValidatorController.$inject = [
        'lodash',
        'MiscUtilsService',
        'KontoUtilsService',
        'AppConfig'
    ];
    function IbanValidatorController(_, MiscUtilsService, KontoUtilsService, AppConfig) {
        var vm = this;

        vm.$onInit = onInit;
        vm.setKontoverbindungViewValues = setKontoverbindungViewValues;
        vm.isAuslaendischeIban = isAuslaendischeIban;
        vm.handleAuslaendischeIban = handleAuslaendischeIban;
        vm.isBlockBanknameBankortErlaubt = isBlockBanknameBankortErlaubt;

        function onInit() {
            vm.regexKontoNr = KontoUtilsService.regexKontoNr;
            vm.regexBlz = KontoUtilsService.regexBlz;
            vm.isValid = false;
            vm.bicEditable = false;
            vm.kontoverbindung = {};

            activate();
        }

        function activate() {}
        function isAuslaendischeIban(iban) {
            return AppConfig.APP.auslaendischeIbanErlaubt && KontoUtilsService.isAuslaendischeIban(iban);
        }
        function handleAuslaendischeIban(iban) {
            if (isAuslaendischeIban(iban)) {
                vm.bicEditable = true;
            } else {
                vm.bicEditable = false;
                vm.banknameEditable = false;
                vm.bankortEditable = false;
            }
        }
        function setKontoverbindungViewValues(kontoverbindung) {
            kontoverbindung = kontoverbindung || {};
            vm.kontoverbindung = kontoverbindung;

            if (MiscUtilsService.isNotEmpty(kontoverbindung)) {
                vm.isValid = true;
            } else {
                vm.isValid = false;
            }
        }
        function isBlockBanknameBankortErlaubt() {
            return (
                !vm.banknameEditable && _.get(vm.kontoverbindung, 'bankname') ||
                !vm.bankortEditable && _.get(vm.kontoverbindung, 'bankort')
            );
        }
    }

    ibanValidator.$inject = [
        '$log',
        '$q',
        'lodash',
        'AppConfig',
        'MiscUtilsService',
        'KontoUtilsService',
        'FormFieldUtilsService'
    ];
    function ibanValidator($log, $q, _, AppConfig, MiscUtilsService, KontoUtilsService, FormFieldUtilsService) {
        return {
            restrict: 'A',
            require: ['?iplusjsValidatorGroup', '^?iplusjsFieldset'],
            templateUrl: 'common/iban/ibanValidator.html',
            link: linkFnc,
            controller: IbanValidatorController,
            controllerAs: 'ibanValidatorVm',
            bindToController: true,
            transclude: true
        };

        function linkFnc($scope, $elem, $attrs, ctrls) {
            var ctrlScope = $scope.ibanValidatorVm,
                validatorGroupCtrl = ctrls[0],
                fieldsetCtrl = ctrls[1],
                onChanged = $scope.$eval($attrs.iivOnChanged) || angular.noop,
                validationItems = validatorGroupCtrl.getItems(),
                ibanItem = getValidationItem(validationItems, 'iban'),
                bicItem = getValidationItem(validationItems, 'bic'),
                banknameItem = getValidationItem(validationItems, 'bankname'),
                bankortItem = getValidationItem(validationItems, 'bankort'),
                ibanQsCodeItem = getValidationItem(validationItems, 'ibanQualitaetscode'),
                lastIbanType;
            $scope.$watchGroup([ibanItem.$attrs.ngModel, bicItem.$attrs.ngModel], function (newValues, oldValues) {
                var iban = _.get(newValues[0], 'id');

                ctrlScope.handleAuslaendischeIban(iban);

                if (MiscUtilsService.isEmpty(iban)) {
                    if (!ctrlScope.bicEditable) {
                        setViewValue(bicItem, null);
                        setViewValue(banknameItem, null);
                        setViewValue(bankortItem, null);
                    }
                    setViewValue(ibanQsCodeItem, null);
                    ctrlScope.setKontoverbindungViewValues(null);
                } else {
                    if (ctrlScope.bicEditable) {
                        setViewValue(ibanQsCodeItem, 'H');
                    }
                }

                if (!validationItems.length || (fieldsetCtrl && fieldsetCtrl.disabled)) {
                    ctrlScope.handleAuslaendischeIban(iban);
                    return;
                }

                if (!_.isEqual(newValues, oldValues)) {
                    $log.debug('$watchGroup changed', ctrlScope.kontoverbindung);

                    ctrlScope.onChanged(ctrlScope.kontoverbindung);
                }
            });
            ctrlScope.validationItems = validationItems;
            ctrlScope.onChanged = onChanged;
            ctrlScope.setViewValue = setViewValue;
            ctrlScope.getValidationItem = getValidationItem;
            ibanItem.$ngModel.$validators.ibanFormat = function (value) {
                var iban = _.get(value, 'id', value),
                    checkIbanResult;

                if (MiscUtilsService.isEmpty(iban)) {
                    return true;
                }

                checkIbanResult = KontoUtilsService.checkIbanFormat(iban);

                if (!checkIbanResult.valid) {
                    setViewValue(bicItem, null);
                    ctrlScope.setKontoverbindungViewValues(null);
                }

                return checkIbanResult.valid;
            };

            ibanItem.$ngModel.$asyncValidators.ibanBic = ibanBicValidator;
            bicItem.$ngModel.$asyncValidators.ibanBic = ibanBicValidator;
            function ibanBicValidator() {
                var iban = ibanItem.$ngModel.$viewValue || _.get(ibanItem.$ngModel.$modelValue, 'id'),
                    bic = bicItem.$ngModel.$viewValue || bicItem.$ngModel.$modelValue,
                    bankname,
                    bankort,
                    ibanType,
                    kontoverbindung = {};

                lastIbanType = KontoUtilsService.isAuslaendischeIban(_.get(ibanItem.$ngModel.$modelValue, 'id')) ? 'AUSLAND' : 'INLAND';

                if (AppConfig.APP.auslaendischeIbanErlaubt && KontoUtilsService.isAuslaendischeIban(iban) && MiscUtilsService.isAtLeastOneEmpty(iban, bic)) {
                    return $q.resolve();
                }

                if (MiscUtilsService.isEmpty(iban) || MiscUtilsService.isAtLeastOneNotEmpty(_.get(ibanItem.$ngModel.$pending, 'ibanBic'), _.get(bicItem.$ngModel.$pending, 'ibanBic'))) {
                    return $q.resolve();
                }

                ibanType = KontoUtilsService.isAuslaendischeIban(iban) ? 'AUSLAND' : 'INLAND';
                bic = (MiscUtilsService.isEmpty(bic) || !ctrlScope.bicEditable) ? null : bic;

                if (lastIbanType && lastIbanType !== ibanType) {
                    setViewValue(bicItem, null);
                    bic = null;
                }

                lastIbanType = ibanType;
                if (ibanType !== 'INLAND' && (!_.isEqual(bicItem.$ngModel.$viewValue, bicItem.$ngModel.$modelValue) || MiscUtilsService.isEmpty(bic))) {
                    setViewValue(banknameItem, null);
                    setViewValue(bankortItem, null);
                }

                bankname = banknameItem.$ngModel.$viewValue || banknameItem.$ngModel.$modelValue;
                bankort = bankortItem.$ngModel.$viewValue || bankortItem.$ngModel.$modelValue;

                return KontoUtilsService.checkIban(iban, bic).then(function (checkedKontoverbindung) {
                    $log.debug('ibanValidator $asyncValidators.iban SUCCESS', checkedKontoverbindung);

                    kontoverbindung.iban = checkedKontoverbindung.iban;
                    kontoverbindung.bic = checkedKontoverbindung.bic;
                    kontoverbindung.kontonummer = checkedKontoverbindung.kontoNummer;
                    kontoverbindung.bankleitzahl = checkedKontoverbindung.bankleitzahl;
                    ctrlScope.banknameEditable = !checkedKontoverbindung.bankname && ctrlScope.isAuslaendischeIban(iban);
                    ctrlScope.bankortEditable = !checkedKontoverbindung.bankort && ctrlScope.isAuslaendischeIban(iban);

                    if (MiscUtilsService.isNotEmpty(kontoverbindung.bic)) {
                        kontoverbindung.bankname = (ctrlScope.banknameEditable ? bankname : checkedKontoverbindung.bankname) || checkedKontoverbindung.bankname;
                        kontoverbindung.bankort = (ctrlScope.bankortEditable ? bankort : checkedKontoverbindung.bankort) || checkedKontoverbindung.bankort;
                    } else {
                        kontoverbindung.bankname = null;
                        kontoverbindung.bankort = null;
                    }

                    ctrlScope.setKontoverbindungViewValues(kontoverbindung);

                    kontoverbindung.ibanQualitaetscode = _.get(ibanQsCodeItem, '$ngModel.$modelValue') || 'H';

                    setViewValue(ibanQsCodeItem, kontoverbindung.ibanQualitaetscode);
                    setViewValue(banknameItem, kontoverbindung.bankname);
                    setViewValue(bankortItem, kontoverbindung.bankort);

                    if (MiscUtilsService.isEmpty(bic) || !ctrlScope.bicEditable) {
                        setViewValue(bicItem, kontoverbindung.bic);
                    }

                    FormFieldUtilsService.renderViewValues(validationItems.map(function (item) {
                        return item.$ngModel;
                    }));

                    return true;
                }).catch(function (error) {
                    $log.debug('ibanValidator $asyncValidators.iban FAILURE', error);

                    ctrlScope.setKontoverbindungViewValues(null);

                    return $q.reject();
                });
            }
            function setViewValue(validationItem, value) {
                if (validationItem) {
                    validationItem.$ngModel.$setViewValue(value);
                    validationItem.$ngModel.$commitViewValue();
                    validationItem.$ngModel.$setPristine();

                    if (validationItem.modelPropName === 'bic' && _.isNil(value)) {
                        validationItem.$elem.val(value);
                    }
                }
            }
            function getValidationItem(validationItems, name) {
                return _.filter(validationItems, {
                    modelPropName: name
                })[0];
            }
        }

    }
})();
